// Minimal theme JS — sticky buy bar logic lives in the section itself
document.addEventListener('DOMContentLoaded', function(){
  // Nothing global required for v1
});

/* ── Mobile nav ── */
function lkToggleMobileNav(){
  var nav = document.getElementById('lk-mobile-nav');
  var overlay = document.getElementById('lk-mobile-overlay');
  var btn = document.getElementById('lk-hamburger');
  var open = nav.classList.toggle('open');
  overlay.classList.toggle('open', open);
  if(btn) btn.classList.toggle('open', open);
  document.body.style.overflow = open ? 'hidden' : '';
}
function lkCloseMobileNav(){
  var nav = document.getElementById('lk-mobile-nav');
  var overlay = document.getElementById('lk-mobile-overlay');
  var btn = document.getElementById('lk-hamburger');
  nav.classList.remove('open');
  overlay.classList.remove('open');
  if(btn) btn.classList.remove('open');
  document.body.style.overflow = '';
}
function lkMobileNavTo(href){
  lkCloseMobileNav();
  setTimeout(function(){
    if(href && href.startsWith('#')){
      var el = document.querySelector(href);
      if(el) el.scrollIntoView({behavior:'smooth'});
    } else if(href){
      window.location.href = href;
    }
  }, 360);
}
